export default __webpack_public_path__ + "static/teamsplus-1-1713e512cd8bfed72029cb56b39118df.svg";